import React, { useEffect, useRef } from 'react';
import AmbSwitch from 'components/common/AmbSwitch';
import AmbGrid from 'components/common/AmbGrid';
import AmbTextField from 'components/common/AmbTextField';
import { theme } from '../../../../theme';
import { styled } from '@mui/system';
import { MenuItem, TextField } from '@mui/material';
import AmbInputLabel from '../../../common/AmbInputLabel';
import { shouldValidateAll } from './BillToFacility.validations';

const StyledTextField = styled(TextField)(({ theme }) => ({
  minWidth: 120,
  marginTop: -1,
  '& .MuiInput-underline:after': {
    borderBottom: '2px solid rgba(0, 0, 0, 0.42)',
  },
  '& .MuiInputLabel-root': {
    fontSize: 15,
    width: 130,
    color: theme.palette.grey.grey80,
    '&.Mui-focused': {
      color: theme.palette.grey.grey80,
    },
  },
}));

const BillToFacilityFrame = props => {
  const { errors, billToFacilityPayer, isBillerVerified } = props;
  const { payerInput, policyNumber, authorizationNumber } = billToFacilityPayer || {};
  const prevProps = useRef(props);

  useEffect(
    () => {
      if (props.hasErrors !== prevProps.current.hasErrors) {
        props.handleErrors(prevProps.current.coordinationTypeId, props.hasErrors);
      }

      if (shouldValidateAll(prevProps.current, props)) {
        props.validateAll(props);
      }

      props.setSaveErrorMessage(props.errors);
      prevProps.current = props;
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [props],
  );

  const labelProps = {
    style: {
      ...theme.mixins.inputLabel,
    },
    shrink: true,
  };

  const billToFacilityStyle = {
    flexDirection: 'column',
    maxWidth: 'inherit',
    padding: 10,
    paddingBottom: props.isBilledToFacility ? 50 : 20,
  };

  const billToFacilityToggleStyle = {
    alignItems: 'center',
    justifyContent: 'space-between',
    margin: '-15px -12px 0px -12px',
    maxWidth: 'inherit',
    padding: 10,
    paddingBottom: 20,
  };

  const billToFacilitySwitchLabelStyle = isBillerVerified ? { opacity: 0.5 } : {};

  return (
    <AmbGrid style={billToFacilityStyle}>
      <AmbGrid style={billToFacilityToggleStyle}>
        <label id="bill-to-facility-switch-label" style={billToFacilitySwitchLabelStyle}>
          <AmbSwitch
            id="bill-to-facility-switch"
            onChange={props.onBillToFacilityToggle}
            checked={props.isBilledToFacility}
            disabled={isBillerVerified}
          />
          Bill to Facility
        </label>
      </AmbGrid>
      {props.isBilledToFacility && (
        <AmbGrid style={{ flexDirection: 'column' }}>
          <AmbTextField
            InputLabelProps={labelProps}
            fullWidth
            name="billToFacilityPayer"
            value={payerInput}
            label="Payer"
            onChange={props.onInputChange}
            required
            id="billToFacilityPayerInput"
            disabled
            readOnly
          />
          <AmbTextField
            InputLabelProps={labelProps}
            fullWidth
            name="authorizationNumber"
            value={authorizationNumber}
            label="Authorized by"
            onChange={props.onInputChange}
            onBlur={props.onInputBlur}
            required
            error={!!errors.authorizationNumber}
            id="billToFacilityAuthorizedByInput"
            readOnly={isBillerVerified}
          />
          <AmbGrid
            style={{
              width: '100%',
              flexDirection: 'column',
              position: 'relative',
            }}
          >
            <AmbInputLabel
              required
              htmlFor="billToFacilityReasonInput"
              shrink
              style={{ fontSize: 15, color: `${theme.palette.grey.grey80}` }}
            >
              Bill Facility Reason
            </AmbInputLabel>
            <StyledTextField
              id="billToFacilityReasonInput"
              select
              variant="standard"
              margin="none"
              name="policyNumber"
              value={policyNumber}
              onChange={props.onInputChange}
              onBlur={props.onInputBlur}
              required
              error={!!errors.policyNumber}
              disabled={isBillerVerified}
            >
              {props.billToFacilityReasons.map(reason => (
                <MenuItem key={reason} value={reason} sx={{ '&.MuiMenuItem-root': { padding: '12px 16px' } }}>
                  {reason}
                </MenuItem>
              ))}
            </StyledTextField>
          </AmbGrid>
        </AmbGrid>
      )}
    </AmbGrid>
  );
};

export default BillToFacilityFrame;
